<template>
  <b-sidebar right v-model="show" class="sidebar-search-new-version" shadow backdrop @change="hasClosedSidebar" ref="sidebar_search">
    <template #header>
      <div class="w-100 d-flex justify-content-between align-items-center px-1">
        <h5 class="m-0">{{ $t('search_preview.profileInfluencer') }}</h5>
        <feather-icon icon="XIcon" class="cursor-pointer" size="20" @click="show = false"></feather-icon>
      </div>
    </template>
    <b-row class="m-0 overflow-none" v-if="loaded_service">

      <!-- Left data of sidebar — YouTube public profile -->
      <b-col class="col-4 px-2 border-bottom-sidebar d-none d-sm-block" v-if="youtube_channel_data">
        <div class="d-flex flex-column align-items-center w-100">
          <b-avatar
            :src="getAvatar()"
            class="p-0 mb-2 avatar-sidebar-search"
          ></b-avatar>
          <h4 class="text-capitalize text-underline cursor-pointer">{{ display_name }}</h4>
          <p class="text-muted-left-side-analytics">{{ getFormat(followers_count) }} {{ $t('search_preview.totalAudience') }}</p>
          <p class="text-muted-left-side-analytics mb-1" v-if="youtube_channel_data.channel.region_code">{{ youtube_channel_data.channel.region_code }}</p>

          <div class="d-flex flex-wrap w-100 mb-2 px-1 gap-50">
            <div class="flex-grow-1 mb-1">
              <add-campaign-and-list
                :data="{username: youtube_channel_data.channel.handle || youtube_channel_data.channel.youtube_id, network: network, followers: followers_count, image: getAvatar()}"
                :lists_dad="lists"
                :favorite_list_dad="favorite_list"
                @update_favorite_list="updateFavoriteList"
              ></add-campaign-and-list>
            </div>
          </div>
        </div>
      </b-col>

      <!-- Left data of sidebar, avatar and add campaign actions -->
      <b-col class="col-4 px-2 border-bottom-sidebar d-none d-sm-block" v-else-if="data_user && data_user.basic">
        <div class="d-flex flex-column align-items-center w-100">
          <b-avatar
            :src="getAvatar()"
            class="p-0 mb-2 avatar-sidebar-search"
          ></b-avatar>
          <h4 class="text-capitalize text-underline cursor-pointer">{{ display_name }}</h4>
          <p class="text-muted-left-side-analytics">{{ getFormat(followers_count) }} {{ $t('search_preview.totalAudience') }}</p>
          <p class="text-muted-left-side-analytics mb-1" v-if="data_user.features && data_user.features.blogger_geo && data_user.features.blogger_geo.data">{{ data_user.features.blogger_geo.data.country }}</p>

          <div class="d-flex flex-wrap w-100 mb-2 px-1 gap-50">
            <div class="flex-grow-1 mb-1">
              <add-campaign-and-list
                :data="{username: data_user.basic.username, network: 'instagram', followers: followers_count, image: getAvatar()}"
                :lists_dad="lists"
                :favorite_list_dad="favorite_list"
                @update_favorite_list="updateFavoriteList"
              ></add-campaign-and-list>
            </div>

          <div class="container-btn-print">
            <b-dropdown variant="link" toggle-class="p-0" no-caret class="w-100">
              <template #button-content>
                <b-button
                  variant="outline-secondary"
                  class="p-09"
                  id="btnPrintSummary"
                >
                  <b-icon icon="printer"/>
                    <b-tooltip
                      target="btnPrintSummary"
                      triggers="hover"
                      placement="top"
                    >
                      {{$t('printSummary')}}
                    </b-tooltip>
                </b-button>
              </template>
              <b-dropdown-item class="force-item-color" @click="shortPrint('png')">{{$t('profile.printPng')}}</b-dropdown-item>
              <b-dropdown-item class="force-item-color" @click="shortPrint('pdf')">{{$t('profile.printPdf')}}</b-dropdown-item>
              <b-dropdown-item class="force-item-color" @click="shortPrint('web')">{{$t('profile.printWeb')}}</b-dropdown-item>
            </b-dropdown>
          </div>
          </div>
        </div>
      </b-col>

      <!-- YouTube public profile right panel -->
      <b-col class="col-12 col-sm-8 background-small p-0" v-if="youtube_channel_data && !error_data">
        <div class="p-1">
          <content-profile-analytics-you-tube
            :channel="youtube_channel_data.channel"
            :videos="youtube_channel_data.videos"
            :private_metrics="youtube_private_metrics"
            @get_profile_url="loadYouTubeAdvancedMetrics"
          ></content-profile-analytics-you-tube>
        </div>
      </b-col>

      <!-- Instagram template right data -->
      <b-col class="col-12 col-sm-8 background-small p-0" v-if="data_user && !error_data && network === 'instagram'">
        <div class="box-expired-report" v-if="has_expired">
          <h5>{{ $t('search_preview.reportExpired') }}</h5>
          <p class="avenir-medium">{{ $t('search_preview.accessFor') }}  {{ $t('preview.days') }}</p>
          <b-button class="blue-button" variant="blue-button" @click.once="getProfileUrl()">{{ $t('lists.update') }}</b-button>
        </div>
        <div class="p-1">

          <content-profile-analytics 
            :data_user="data_user" 
            :network="network"
            :is_paid="is_paid"
            :has_expired="has_expired"
            :subscribers_growth_prc_graph="subscribers_growth_prc_graph"
            :mentions_avatares="mentions_avatares"
            :mentions_user="mentions_user"
            :categories="formatted_categories"
            @get_profile_url="unlockReport"
          ></content-profile-analytics>
  
        </div>
      </b-col>

      <!-- Twitter template right data -->
      <b-col class="col-12 col-sm-8 background-small p-0" v-if="data_user && !error_data && network === 'twitter'">
        <div class="p-1">
          <content-profile-analytics-twitter
            :data_user="data_user" 
            :is_paid="is_paid"
            :network="network"
            @get_profile_url="unlockReport"
          />
        </div>
        
      </b-col>

      <!-- Twitch template right data -->
      <b-col class="col-12 col-sm-8 background-small p-0" v-if="data_user && !error_data && network === 'twitch'">
        <content-profile-analytics-twitch
          :is_paid="is_paid"
          :data_user="data_user" 
          :network="network"
          @get_profile_url="unlockReport"
          >
        </content-profile-analytics-twitch>
      </b-col>


            <!-- TikTok template right data -->
      <b-col class="col-12 col-sm-8 background-small p-0" v-if="data_user && !error_data && network === 'tiktok'">
        <content-profile-analytics-tiktok
            :data_user="data_user"
            :network="network"
            :is_paid="is_paid"
            :has_expired="has_expired"
            :subscribers_growth_prc_graph="subscribers_growth_prc_graph"
            :mentions_avatares="mentions_avatares"
            :mentions_user="mentions_user"
            :categories="formatted_categories"
            @get_profile_url="unlockReport"
          ></content-profile-analytics-tiktok>
      </b-col>

      <!-- Error data of getting data -->
      <b-col v-else-if="error_data" class="col-12 background-small py-1">
        <div class="alert-card" >
          <div class="alert-icon">
            <feather-icon icon="LockIcon" size="20" />
          </div>
          <div class="alert-content">
            <span class="text-gray f-16">{{ $t(`creator.unableProfile`)}}</span>
            <p class="text-gray avenir-medium mb-0"> 
              {{ $t(`creator.againLater`)}}
            </p>
          </div>
        </div>
      </b-col>
    </b-row>

    <!-- Skeleton for simulating loading page -->
    <b-row v-else class="m-0 overflow-none">
      <b-col class="col-4 px-2 border-bottom-sidebar">
        <div class="d-flex flex-column align-items-center">
          <b-skeleton class="avatar-sidebar-search"></b-skeleton>
          <b-skeleton class="col-9 mb-02"></b-skeleton>
          <b-skeleton class="col-6 mb-02"></b-skeleton>
          <b-skeleton class="col-12 mt-2 p-1"></b-skeleton>
        </div>
      </b-col>

      <b-col class="col-8 background-small py-1">
        <div class="grid-container mb-2 min-height-281">
          <div class="grid-item" v-for="(index) in 5" :key="index">
            <b-skeleton class="w-100 h-100"></b-skeleton>
          </div>
        </div>

        <div class="grid-analytics mb-2">
          <div class="grid-item min-height-116" v-for="(index) in 4" :key="index">
            <b-skeleton class="w-100 h-100"></b-skeleton>
          </div>
        </div>

        <div class="mb-2 min-height-321">
          <b-skeleton class="w-100 h-100"></b-skeleton>
        </div>

        <div class="mb-2 min-height-232">
          <b-skeleton class="w-100 h-100"></b-skeleton>
        </div>
      </b-col>

    </b-row>
    <short-print v-if="(!loading || printing) && network !== 'youtube' && network !== 'youtube_internal'" :format="format_print" :avatar="avatar_print" :modalShow="showPrintShort" :key="changePrint" @closeLoader="closeLoader" :network="network" :username="username"/>
  </b-sidebar>
</template>

<script>
import { 
  BSidebar, 
  BRow, 
  BCol,
  BAvatar,
  BButton,
  BSkeleton,
  BDropdown,
  BDropdownItem,
  BTooltip,
} from "bootstrap-vue";
import { getSummaryInfluencer, getHistorySuscribers, getInfluencerIn, getSummaryInfluencerTiktok, getHistorySuscribersLaravel, unlockReport, getYouTubePublicProfile, getYouTubePrivateMetrics } from '@/services/search';
import { getFormat, checkNumber, separatebycomma } from "@/libs/utils/formats";
import { getCategoryIconSearcher, getIconInterest } from "@/libs/utils/icons";
import { hasPermission } from "@/libs/utils/user";
import shortPrint from '@/views//pages/profile/shortPrint.vue';
import { getMotivationalPhrase } from '@/libs/utils/others';
import { getCategories } from "@/services/search-refactored";
const loadToastificationContent = () => import('@core/components/toastification/ToastificationContent.vue');

export default {
  name: "SidebarSearchNew",
  components: {
    shortPrint,
    BDropdown,
    BDropdownItem,
    BTooltip,
    BSidebar,
    BRow,
    BCol,
    BButton,
    BSkeleton,
    BAvatar,
    AddCampaignAndList: () => import('@/views/components/dropdowns/addCampaignAndList.vue'),
    ContentProfileAnalytics: () => import('@/views/components/sidebar/ContentProfileAnalytics.vue'),
    ContentProfileAnalyticsTwitch: () => import('@/views/components/sidebar/twitch/ContentProfileAnalyticsTwitch.vue'),
    ContentProfileAnalyticsTwitter: () => import('@/views/components/sidebar/twitter/ContentProfileAnalyticsTwitter.vue'),
    ContentProfileAnalyticsTiktok: () => import('@/views/components/sidebar/tiktok/ContentProfileAnalyticsTiktok.vue'),
    ContentProfileAnalyticsYouTube: () => import('@/views/components/sidebar/youtube/ContentProfileAnalyticsYouTube.vue')
  },
  props: {
    open_sidebar: {
      type: Boolean
    },
    username: {
      type: String,
      default: ''
    },
    network: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      getFormat,
      checkNumber,
      getCategoryIconSearcher,
      getIconInterest,
      separatebycomma,
      show: this.open_sidebar,
      lists: [],
      campaigns: [],
      background_default: require("@/assets/images/dashboard/imgDefault.png"),
      update_image: false,
      data_user: null, 
      error_data: false,
      subscribers_growth_prc_graph: null,
      mentions_user: null,
      mentions_avatares: [],
      loaded_service: false,
      loaded_service_add: false,
      favorite_list: { with_influencer: false},   
      is_paid: false,
      has_expired: false,
      youtube_channel_data: null,
      youtube_private_metrics: null,
      format_print: 'pdf',
      showPrintShort: false,
      changePrint: 0,
      printing: false,
      avatar_print: '',
      loading: false,
      categories: []
    }
  },
  created() {
    this.getData();
  },
  computed: {
    display_name() {
      if (this.youtube_channel_data) return this.youtube_channel_data.channel.title || this.youtube_channel_data.channel.handle || '-';
      if (!this.data_user) return '-'
      return (this.data_user.basic && (this.data_user.basic.title || this.data_user.basic.username)) ? (this.data_user.basic.title || this.data_user.basic.username) : (this.data_user.basic?.username || '-')
    },
    followers_count() {
      if (this.youtube_channel_data) return this.youtube_channel_data.channel.subscriber_count || 0;
      if (this.data_user?.metrics.subscribers_count.value) return this.data_user.metrics.subscribers_count.value
      return 0
    },
    host() {
      return window.location.host;
    },
    formatted_categories() {
      if (!this.categories.length || !this.data_user?.features) return [];
      const feature_key = 'blogger_labels';
      const IDs = this.data_user.features?.[feature_key]?.data?.slice(0, 6) || [];
      return IDs.map(id => this.categories.find(cat => cat.id === id)?.title).filter(Boolean);
    },
  },
  methods: {
    loadYouTubeAdvancedMetrics() {
      if (!this.youtube_channel_data) return;
      const channelId = this.youtube_channel_data.channel.handle || this.youtube_channel_data.channel.youtube_id;
      getYouTubePrivateMetrics(channelId).then((metrics) => {
        if (metrics && metrics.stats) this.youtube_private_metrics = metrics.stats;
      });
    },
    shortPrint(format) {
      if (format === 'web') {
        window.open(`/resumen/perfil/${this.network}/${this.username}`);
      } else {
        this.printShort(format)
      }
    },
    printShort(format) {
      this.printing = true;
      this.$vs.loading({
        type: 'sound',
        background: 'rgba(255, 255, 255, 1)',
        text: getMotivationalPhrase(),
      });

      this.interval_loading = setInterval(() => {
        const prev_loading = document.getElementsByClassName('con-vs-loading')[0]

        if (prev_loading) {
          prev_loading.classList.add('fade-out');
          setTimeout(function() {
            prev_loading.remove()
          }, 500);

          this.$vs.loading({
            type: 'sound',
            background: 'rgba(255, 255, 255, 1)',
            text: getMotivationalPhrase(),
          });
        }
      }, 5000);
      this.format_print = format
      this.avatar_print = this.getAvatar();
      this.showPrintShort = true;
      this.changePrint += 1;
      this.printing = false;
    },
    closeLoader() {
      setTimeout(() => {
        this.loading = false;
        this.$vs.loading.close()
        clearInterval(this.interval_loading)
      }, 500);
    },
    getAvatar() {
      if (this.youtube_channel_data) return this.youtube_channel_data.channel.thumbnail_url || this.background_default;
      if (!this.data_user) return this.background_default;
      const basic = this.data_user.basic || {};

      if (basic.avatar_url) return basic.avatar_url;

      const username_obj = basic.username || {};
      if (username_obj.name?.ava || username_obj.name?.avatar) return username_obj.name.ava || username_obj.name.avatar;
      if (username_obj.avatar) return username_obj.avatar;

      return this.background_default;
    },
    mentionsCase(post_frequency) {
      let traduction = '';
      switch (true) {
      case post_frequency > 21:
        traduction = 'mentions_text_mark.frequency'
        break;
      case post_frequency > 14:
        traduction = 'mentions_text_mark.optimal_above'
        break;
      case post_frequency > 6:
        traduction = 'mentions_text_mark.optimal'
        break;
      case post_frequency > 4:
        traduction = 'mentions_text_mark.below_optimal'
        break;
      default:
        traduction = 'mentions_text_mark.not_frequency'
        break;
      }
      return traduction;
    },
    getData() {
      if (this.network !== 'youtube' && this.network !== 'youtube_internal') {
        this.getCategoriesService();
      }

      if (this.network === 'youtube' || this.network === 'youtube_internal') {
        getYouTubePublicProfile(this.username).then((response) => {
          if (!response || response.status === 'error') {
            this.error_data = true;
            this.loaded_service = true;
            return;
          }
          this.youtube_channel_data = response;
          this.youtube_private_metrics = null;
          this.loaded_service = true;
        });
        return;
      }

      if (this.network === 'tiktok') {
        getSummaryInfluencerTiktok(this.network, this.username).then((response) => {
          if (response.error || (response?.status && response?.status !== 200)) {
            this.error_data = true;
            this.data_user = {};
            this.loaded_service = true;
            return;
          }

          this.data_user = response.report;
          this.is_paid = response.is_paid
          this.has_expired = response.is_expired
          const blogger_mentions = this.data_user?.features?.blogger_mentions?.data || null;

          // Verificamos si existen menciones válidas
          if (
            blogger_mentions &&
            blogger_mentions.mentions &&
            blogger_mentions.mentions.performance &&
            blogger_mentions.mentions.performance["180d"] &&
            Array.isArray(blogger_mentions.mentions.performance["180d"].data) &&
            blogger_mentions.mentions.performance["180d"].data.length > 0
          ) {
            this.mentions_user = blogger_mentions.mentions.performance["180d"];
          } else {
            this.mentions_user = null;
          }

          // Construcción de avatares solo si hay menciones válidas
          this.mentions_avatares = [];
          if (this.mentions_user && blogger_mentions.users) {
            for (const user in blogger_mentions.users) {
              if (blogger_mentions.users[user]?.avatar_url) {
                this.mentions_avatares.push(blogger_mentions.users[user].avatar_url);
              }
            }
            this.mentions_avatares = this.mentions_avatares.slice(0, blogger_mentions.mentions.performance["180d"].data.length);
          }
          this.loaded_service = true;

        });
      } else {
        getSummaryInfluencer(this.network, this.username).then((response) => {
          if (response.error || (response?.status && response?.status !== 200)) {
            this.error_data = true;
            this.data_user = {};
            this.loaded_service = true;
            return;
          } else if (this.network === 'instagram') {
            this.data_user = response.report;
            this.is_paid = response.is_paid
            this.has_expired = response.is_expired

            this.mentions_user = !Array.isArray(this.data_user.features.blogger_mentions) ? this.data_user.features.blogger_mentions.data.mentions.performance["180d"] : null;
            if (this.mentions_user) {
              for (const user in this.mentions_user.users) {
                this.mentions_avatares.push(this.mentions_user.users[user].avatar_url)
              }
              this.mentions_avatares = this.mentions_avatares.slice(0, this.data_user.features.blogger_mentions.data.reports.length)
            }
          } else if (this.network === 'twitch' || this.network === 'twitter') {
            this.data_user = response.report;
            this.is_paid = response.is_paid
          }

          this.loaded_service = true;
        })
      }

      this.fetchSubscribersHistory(this.username)

      this.getInfluenerInLists(this.username);
    },
    getCategoriesService() {
      getCategories(this.network).then((response) => {
        this.categories = response.labels ?? [];
      });
    },
    getInfluenerInLists(username) {
      getInfluencerIn(username, this.network , 'lists').then((response) => {
        this.lists = response.results.filter(list => {
          if (!list.is_favorite) return list;
          else this.favorite_list = list;
        })
      })
    },
    // To get data from graph growth of subscribers
    fetchSubscribersHistory(username) {
      const fetchFunction = this.network === "instagram" ? getHistorySuscribers : getHistorySuscribersLaravel;
      const metric_key = this.network === "instagram" ? "followers_count" : "subscribers_count";

      fetchFunction({ network: this.network, username })
        .then((response) => {
          if (response && Array.isArray(response.metrics) && response.metrics[metric_key]) {
            this.subscribers_growth_prc_graph = response.metrics[metric_key].history.map(item => ({
              count: item.value,
              date: Math.floor(new Date(item.time_iso).getTime() / 1000)
            }));
          }
        });
    },

    updateFavoriteList(status, user_added = null) {
      this.favorite_list.with_influencer = (status === 'added');
      if (user_added) {
        this.favorite_list.list_element_uuid = user_added.uuid;
      }
    },
    unlockReport() {
      if (hasPermission('view_profile')) {
        const data = {
          username: this.username,
          network: this.network
        }

        unlockReport(data).then((response) => {
          if (response.processing) {
            loadToastificationContent().then((component) => {
              this.$toast({
                component: component.default,
                position: 'top-right',
                props: {
                  title: 'Obteniendo métricas',
                  text: 'Estamos trabajando para obtener toda la información posible del perfil, puedes seguir navegando y te avisaremos cuando este lista',
                  icon: 'CoffeeIcon',
                  variant: 'success',
                }
              })
            })
          } else {
            this.$toast.clear();
            this.$router.push({name: 'auth-perfil', params: {'alias': this.username, 'network': this.network}})
          }
        })
      }
    },
    getProfileUrl() {
      if (hasPermission('view_profile')) {
        // TODO: Desbloquear perfil
        const alias = this.username;
        this.$router.push({name: 'auth-perfil', params: {network: this.network, alias}})
      }
    },
    errorLoad(content) {
      content.basic.preview_url = this.background_default;
      this.update_image = !this.update_image;
      return this.background_default;
    },
    hasClosedSidebar() {
      this.$refs.sidebar_search.$el.classList.remove('open-sidebar-search')
    },
  },
};
</script>
<style scoped lang="scss">
.gap-50 {
  gap: 0.5em;
}
.container-btn-print {
  flex-shrink: 0;
}
.overflow-none {
  height: auto;
  min-height: 100%;
}
.spinner-dropdown-item {
  position: absolute;
  right: 19px;
  background-color: white;
  height: 16px;
  width: 16px;
  color: #ccc;
}
.text-muted-left-side-analytics {
  font-size: 14px;
  font-family: 'avenir-medium';
  color: #718096;
  margin-bottom: 0.3em;
}
.border-bottom-sidebar {
  position: relative;
  height: fit-content;
  top: 15px;
}
.background-small {
  background-color: #F5F8FA;
  overflow-y: scroll;
  border-left: 1px solid #e2e8f0;
}
.text-underline {
  text-decoration: underline;
}

.container-loader-searcher {
  height: 100%;
  width: 100%;
  position: absolute;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 10;
  top: 0px;
  left: 0px;
}
.grid-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;

  .grid-item {
    &:nth-child(1) {
      grid-column-start:1;
      grid-column-end: 3;
      grid-row-start: 1;
      grid-row-end: 3;
      
      .img-cover {
        border-top-left-radius: 6px;
        border-bottom-left-radius: 6px;
        height: 281px;
      }
    }
    &:nth-child(3) {
      .img-cover {
        border-top-right-radius: 6px;
      }
    }
    &:nth-child(5) {
      .img-cover {
        border-bottom-right-radius: 6px;
      }
    }
  }
}
.mr-05 {
  margin-right: 0.2em;
}
.mb-02 {
  margin-bottom: 0.4em;
}
.min-height-281 {
  min-height: 281px;
}
.min-height-116 {
  min-height: 116px;
}
.min-height-321 {
  height: 321px;
  min-height: 321px;
}
.min-height-232 {
  height: 232px;
  min-height: 232px;
}
.box-expired-report {
  background-color: white;
  padding: 36px 0px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.box-style-analytics {
  border-radius: 6px;
  box-shadow: 0 1px 4px #0b14260a;
  padding: 16px;
  background-color: white;
  border: 1px solid #E2E8F0;
  .grid-inner-box {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 10px;
    .inner-box {
      border: 1px solid #E2E8F0;
      border-radius: 6px;
      box-shadow: 0 1px 4px #0b14260a;
      padding: 16px;
    }
  }
  .grid-more-info {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(4);
    gap: 10px;

  }
}

.grid-analytics {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;

}
.icon-coin {
  width: 20px;
  height: 20px;
}
.block-emtpy-data {
  background-color: #eff3f6;
  border-radius: 6px;
  border: 1px solid #f0f0f0;
  .container-icon-lock {
    background-color: #0096fe;
    padding: 1em;
    overflow: hidden;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;

  }
  .icon-lock {
    color: white;
    width: 30px;
    height: 30px;
  }
}


.backgroud-gray-light-avatar {
  background-color: #eff3f6;
  color: #687385;
}
.f-16 {
  font-size: 16px;
}
</style>
<style lang="scss">
.sidebar-search-new-version > .b-sidebar {
  width: 910px !important;
}
.avatar-sidebar-search {
  width: 120px;
  height: 120px;
  object-fit: cover;
  border-radius: 100%;
}
.sidebar-search-new-version .bg-light{
  background-color: white !important;
}
.sidebar-search-new-version .b-sidebar-header {
  padding: 1em 0;
  font-size: 13px !important;
  border-bottom: 1px solid #e2e8f0;
}
.close-sidebar-icon:hover {
  background-color: rgba(219, 219, 219, 0.5);
  border-radius: 50%;
  cursor: pointer;
}
.container-thubnail {
  position: relative;
  overflow: hidden;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
  border-radius: 1em;
}
.thubnail-contents-sidebar {
  width: 280px;
  height: 280px;
  object-fit: cover;
  border-radius: 1em !important;
  display: block;
}
.container-thubnail:hover {
  cursor: pointer;
}
.container-thubnail:hover .container-text-sidebar {
  animation: animation-text 400ms;
  display: block;
}
.container-reations-sidebar {
  background-color: white;
  height: 50px;
  width: 280px;
  position: absolute;
  bottom: 0em;
  border-radius: 0.6em;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  padding: 0 0.5em;
}
.container-text-sidebar {
  background: rgb(0, 0, 0, 0.5);
  color: white;
  position: absolute;
  top: 0;
  height: 240px;
  padding: 1em;
  width: 280px;
  border-radius: 1em;
  display: none;
  overflow: hidden;
  font-size: 13px;
}
.padding-right-01 {
  padding-right: 0.2em;
}
.spinner-searcher-sidebar {
  width: 4em;
  height: 4em;
  color: gray;
  margin: 15em 0 0 0;
}
.margin-category-badge {
  margin: 0.3em 0.3em 0.3em 0;
}
.container-drop-items {
  // width: 250px;
  width: 100%;
}
.container-drop-items > a:hover {
  background-color: #ccc !important;
}
.outline-blue-hover .btn-group {
  border: none !important;
}
.outline-blue-hover {
  cursor: pointer;
  background-color: white;
  border: 1px solid #0096fe;
  color: #0096fe;
  padding: 11px 21px;
  border-radius: 0.5em;
}
.outline-blue-hover:hover {
  background-color: #0096fe;
  color: white;
  transition: all 300ms;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}
.dropdown-color > button {
  padding: 0 !important;
  border: none !important;
  background-color: transparent !important;
  box-shadow: none !important;
}

@keyframes animation-text {
  0% {
    transform: translateY(300px);
  }
  100% {
    transform: translateX(0px);
  }
}
.alert-card {
  display: flex;
 ;
  background-color: #b8c2cc;
  border-radius: 6px;
  margin-top: 1rem;
}

.alert-icon {
  align-items: center;
  background-color: #f87171;
  color: white;
  padding: 1.5rem;
  border-radius: 4px 0px 0px 4px;
  display: flex;
  justify-content: center;
}

.alert-content {
  padding: 1rem;
  display: flex;
  flex-direction: column;
}
</style>
